<div style="width: fit-content; border-radius: 15px; padding: 3%; margin: auto;">
  <img style="width: 200px;" class="" src="../assets/images//elso-logo-big.png">
  <br /><br /><br />
  <p>Access Denied. Your role does not allow Registry access.</p>
  <p>{{errorMessage}}</p>
  <br />
  <button type="button" color="primary" mat-raised-button (click)="redrectToElsoWebste()">Return to ELSO website</button>
</div>
